import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=66dbdb65&scoped=true"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=66dbdb65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbdb65",
  null
  
)

export default component.exports